import {FACTIONS} from "../../../constants/factions";

export const DOPPLERS_QUOTES = [{
  quote: 'Мы не предаём. Мы просто меняем лицо вместе с обстоятельствами. Вопросы к тем, у кого лицо одно',
  author: 'Клодия Альтерра, допплер-префект Амбиций',
  factionId: FACTIONS.DOPPLERS
}, {
  quote: 'Договор, подписанный утром, к вечеру — хорошая салфетка',
  author: 'Секст Мендактор, допплер-проконсул Временных истин',
  factionId: FACTIONS.DOPPLERS
}, {
  quote: 'Сложнее всего убить того, кого ты только что назвал братом. Но мы научились',
  author: 'Ливия Дуплекс, допплер-цензор Клятв',
  factionId: FACTIONS.DOPPLERS
}, {
  quote: 'Правда? Зачем вам правда? Вам нужна победа. А я продам вам и ту, и другую, и третью — любую',
  author: 'Постумий Сикофанта, допплер-магистр Разменных монет',
  factionId: FACTIONS.DOPPLERS
}, {
  quote: 'У меня тысяча лиц. И ни одного своего. Своё лицо — это уязвимость',
  author: 'Мамерк Суран, верховный допплер-герольд Двойных вестей',
  factionId: FACTIONS.DOPPLERS
}, {
  quote: 'Союз — это красивое слово. Означает оно: "я пока тебя не предал, потому что ты мне полезен"',
  author: 'Тиберий Фалс, допплер-эдил Сломанных печатей',
  factionId: FACTIONS.DOPPLERS
}, {
  quote: 'Легче всего обмануть того, кто верит в честность',
  author: 'Вибия Спекула, допплер-инспектор Зеркальных канцелярий',
  factionId: FACTIONS.DOPPLERS
}, {
  quote: 'Клятва — это звук. А звуки забываются. Контракты — бумага. А бумага горит',
  author: 'Квинт Фалькон, допплер-префект Прелюбодейного след',
  factionId: FACTIONS.DOPPLERS
}, {
  quote: 'Правда? Скучно. У правды одно лицо. А я люблю разнообразие',
  author: 'Юния Симия, допплер-авгур Перекрестков',
  factionId: FACTIONS.DOPPLERS
}, {
  quote: 'Верить можно только своей паранойе. И то — не всегда',
  author: 'Марк Лициний Хамелеон, допплер-куратор Сената Теней',
  factionId: FACTIONS.DOPPLERS
}]